import React, {useState, useEffect} from 'react'
import {useNavigate} from "react-router-dom"
import { Tick } from 'react-crude-animated-tick';
import './success.css'
import { useIdleTimer } from 'react-idle-timer'
import Swal from 'sweetalert2';
import ScaleLoader from "react-spinners/ScaleLoader";

const Success = () => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
      setLoading(true)
      setTimeout( () => {
          setLoading(false)
      }, 800)

  },[])
    const navigate = useNavigate()

    const handleOnIdle = () => {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'You were idle for too long!',
          })
        navigate('/idle')
      }
    
    useIdleTimer({
        timeout: 1000 * 60 * 10,
        onIdle: handleOnIdle,
      })
     
    return (
        <div>
              { loading ?  
            <div className='spinner'>
            <ScaleLoader color={'#ffa500'} loading={loading} size={150}/>
            </div>
           : 
        
        <div style={{backgroundColor: '#F7931E', position: 'relative', width: '100vw', height: '100vh'}}>
           
            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%', textAlign: 'center', color: 'white'}}>
                <h1 >Thank You!</h1>
                <br/>
                <Tick style={{margin: '0 auto'}}/>

                <h5>Your order has been received.</h5>
            
               
                <br></br>

                <button onClick={()=>navigate('/History')} style={{background: '#F7931E', border: '1px solid white', color: 'white', borderRadius: '15px', padding: '15px 10px', marginBottom:'20px', fontWeight: 'bold', outline: 0 }}>View Order History</button>
                
                <br></br>
                
                <button onClick={()=>navigate('/Browse')} style={{background: '#F7931E', border: '1px solid white', color: 'white', borderRadius: '15px', padding: '15px 10px', fontWeight: 'bold', outline: 0 }}>Back to Menu</button>

                <br></br>

                <h6>Or</h6>
                <button onClick={()=>navigate('/Game')} style={{background: 'white', border: '1px solid white', color: '#F7931E', borderRadius: '15px', padding: '15px 10px', fontWeight: 'bold', outline: 0 }}>Play Jump Game</button>

            </div>
        </div>
       }
      </div>
    )
}

export default Success
